import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ITenantMemberUser } from 'src/interfaces/TenantMember';
import { getActiveTenantUsers } from 'src/services/TenantsService';

export const useGetTenantUsers = (
	searchText?: string,
	pageSize?: number
): UseQueryResult<ITenantMemberUser[]> => {
	return useQuery({
		queryKey: ['tenantUsers', searchText, pageSize],
		queryFn: () => getActiveTenantUsers(searchText, pageSize)
	});
};
